<template>
<section class="about-us-section" v-bind="sectionAttributes">
  <div class="static-container">
    <header v-if="section.heading" class="about-us-section-header">
      <i v-if="hasIcon" class="about-us-section-icon" :class="iconClass"></i>
      <h1 class="about-us-section-header-heading" v-html="section.heading"></h1>
      <p v-if="section.subheading" class="about-us-section-description" v-html="section.subheading"></p>
    </header>
    <template v-else>
      <i v-if="hasIcon" class="about-us-section-icon" :class="iconClass"></i>
    </template>

    <div class="about-us-section-wrapper" :class="sectionWrapperClasses">
      <div v-if="shouldDisplayHeadingWrapper" class="about-us-section-heading-wrapper">
        <template v-if="section.title">
          <h1 class="about-us-section-heading" v-html="section.title"></h1>
          <div class="about-us-section-heading-divider"></div>
        </template>
        <p v-if="section.description" class="about-us-section-description" v-html="section.description"></p>
      </div>
      <div class="about-us-section-content-wrapper">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: ['section', 'section-class', 'without-heading'],

  computed: {
    shouldDisplayHeadingWrapper() {
      if (this.withoutHeading === true) {
        return false
      }

      return this.section.title || this.section.description
    },

    hasIcon() {
      return !!this.section.icon
    },

    iconClass() {
      return this.section.icon || ''
    },

    sectionWrapperClasses() {
      const classes = []

      if (!this.section.size) {
        return classes
      }

      switch (this.section.size) {
        case 'half':
        case 'full':
          classes.push(`about-us-section-content-wrapper-${this.section.size}`)
          break
      }

      return classes
    },

    sectionAttributes() {
      let attributes = {}
      attributes.name = this.section.name
      attributes.class = [ this.sectionClass ]
      attributes.style = {}

      if (this.section.background) {
        attributes.class.push('about-us-section-has-background')
        attributes.style['background-image'] = this.sectionBackground
      }

      if (this.section.without_context_background) {
        attributes.class.push('about-us-section-without-context-background')
      }

      return attributes
    },

    sectionBackground() {
      if (!this.section.background) {
        return ''
      }

      let background = `url(${this.section.background})`

      if (this.section.background_gradient) {
        return `linear-gradient(rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12)), ${background}`
      }

      return background
    }
  },
})
</script>

<style lang="less">
.about-us-section {
  @apply py-16 px-4;

  &.about-us-section-has-background {
    background-position: 100%;
    background-repeat: no-repeat;
  }

  .about-us-section-icon {
    @apply text-2xl text-primary mb-4;
  }

  .about-us-section-heading-divider {
    @apply bg-primary mt-4;
    width: 50px;
    height: 2px;
  }

  .about-us-section-header {
    @apply w-full text-center mb-16;

    .about-us-section-header-heading {
      @apply text-sm font-bold mt-2;
    }

    .about-us-section-icon {
      @apply text-base mb-0;
    }
  }

  .about-us-section-description {
    @apply mt-4 mb-0;
  }

  .about-us-section-wrapper {
    @apply w-full;

    .about-us-section-heading-wrapper {
      @apply w-full mb-4;

      .about-us-section-heading {
        @apply text-3xl font-bold;
      }
    }

    .about-us-section-content-wrapper {
      @apply w-full;
    }
  }

  .about-us-section-content-card {
    @apply w-full mb-4;

    .about-us-section-content-card-image {
      @apply w-full mb-4;

      img {
        @apply w-full rounded-lg;
      }
    }

    .about-us-section-content-card-body {
      @apply w-full;

      .about-us-section-content-card-heading {
        @apply mb-2 text-lg font-bold;
      }

      .about-us-section-content-card-text {
        @apply text-grey-dark;
      }
    }
  }
}

@screen lg {
  .about-us-section {
    .about-us-section-wrapper {
      @apply w-full flex;

      .about-us-section-heading-wrapper {
        @apply w-1/3;
      }

      .about-us-section-content-wrapper {
        @apply w-2/3;
      }

      .about-us-section-content-card {
        @apply w-full flex;

        .about-us-section-content-card-image {
          @apply w-1/3;
        }

        .about-us-section-content-card-body {
          @apply w-2/3 px-4;
        }

        &.about-us-section-content-card-image-only {
          .about-us-section-content-card-image {
            @apply w-2/3;
          }

          .about-us-section-content-card-body {
            @apply hidden;
          }
        }
      }

      &.about-us-section-content-wrapper-half {
        .about-us-section-heading-wrapper {
          @apply w-1/2;
        }

        .about-us-section-content-wrapper {
          @apply w-1/2;
        }
      }

      &.about-us-section-content-wrapper-full {
        .about-us-section-heading-wrapper {
          @apply w-full;
        }

        .about-us-section-content-wrapper {
          @apply w-full;
        }
      }
    }
  }
}
</style>
